import { render, staticRenderFns } from "./yi_dictionary_select.vue?vue&type=template&id=67d13d7c&scoped=true&"
import script from "./yi_dictionary_select.vue?vue&type=script&lang=js&"
export * from "./yi_dictionary_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d13d7c",
  null
  
)

export default component.exports